import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { useCountdown } from '../hooks/useCountdown';
export function MastersSection() {
  const {
    isExpired
  } = useCountdown();
  return <div id="masters" className="grain-section w-full px-6 py-32 md:py-40 bg-page-bg" data-id="element-114">
      <div className="max-w-6xl mx-auto space-y-24" data-id="element-115">
        {/* Chapter Indicator */}
        <div className="flex flex-col md:flex-row md:items-center gap-8 mb-8" data-id="element-116">
          <div className="text-8xl md:text-9xl font-black text-black/5 font-sans tracking-tighter" data-id="element-117">
            03
          </div>
          <div className="h-px w-24 bg-black/10 hidden md:block" data-id="element-118"></div>
          <div data-id="element-119">
            <p className="text-xs text-teal-600 font-bold tracking-widest uppercase mb-3" data-id="element-120">
              Chapter Three
            </p>
            <h2 className="text-4xl md:text-6xl font-bold text-ink tracking-tight" data-id="element-121">
              Who Are The Masters?
            </h2>
          </div>
        </div>

        <div className="text-xl text-ink-light max-w-3xl font-light leading-relaxed" data-id="element-122">
          <p data-id="element-123">
            Let me introduce you to the two people who'll be running these
            sessions. Both are founders of the Peptide Science Institute. Both
            have track records of doing what most people in medicine still call
            "impossible."
          </p>
        </div>

        {/* Dr. Ali Mazloum */}
        <div className="bg-white rounded-[2.5rem] p-10 md:p-16 shadow-md border border-black/5" data-id="element-124">
          <div className="grid md:grid-cols-[1fr_2fr] gap-12 items-start" data-id="element-125">
            <div className="space-y-6" data-id="element-126">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/r3ytD56TFByCqkHoB8LFzP/DrAli1.png" alt="Dr. Ali Mazloum" className="w-full max-w-[280px] h-auto rounded-3xl bg-gray-100" data-id="element-127" />
              <div data-id="element-128">
                <h3 className="text-3xl font-bold text-ink tracking-tight" data-id="element-129">
                  Dr. Ali Mazloum
                </h3>
                <p className="text-teal-600 font-semibold tracking-wide uppercase mt-2 text-sm" data-id="element-130">
                  The Human MRI
                </p>
              </div>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-ink-light font-light leading-relaxed" data-id="element-131">
              <p data-id="element-132">
                Ali's the guy other doctors call when they're completely
                stumped. He works in one of the largest hospitals in Russia...
                And physicians routinely bring him "impossible cases"... Because
                he has this almost supernatural ability to see what everyone
                else has missed.
              </p>
              <p data-id="element-133">
                He's reversed conditions that conventional medicine insists are
                incurable: Type 1 and type 2 diabetes... Rheumatoid arthritis...
                Cerebral vasculitis... Asthma, eczema, COPD, Graves' disease...
                He's restored kidney function in patients facing dialysis.
              </p>
              <div className="pl-8 border-l-4 border-teal-400 text-ink italic" data-id="element-134">
                <p data-id="element-135">
                  Elite entrepreneurs, CEOs, athletes, and physicians themselves
                  come to him when nobody else can figure out what's wrong. And
                  they often experience recoveries modern medicine still insists
                  are impossible.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12" data-id="element-136">
            <TestimonialCard text="Hell-o Dr. Ali… I'm currently finishing up a program I started with Brenden... I'm 71… I lift 50 to 80 pound boxes full of food and drinks everyday. I plan on working until I can't. I swim 5 days a week and go to the gym 3 days a week. My performance has increased greatly since Brenden put me on his program… Thank you for all you guys and girls do for everyone!" name="Kenneth F., Meeting With the Master Client" data-id="element-137" />
          </div>
        </div>

        {/* Brenden Henry */}
        <div className="bg-white rounded-[2.5rem] p-10 md:p-16 shadow-md border border-black/5" data-id="element-138">
          <div className="grid md:grid-cols-[1fr_2fr] gap-12 items-start" data-id="element-139">
            <div className="space-y-6" data-id="element-140">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vptGHfonavjt96KY7KsnCE/Image_2.jpg" alt="Brenden Henry" className="w-full max-w-[280px] h-auto rounded-3xl bg-gray-100" data-id="element-141" />
              <div data-id="element-142">
                <h3 className="text-3xl font-bold text-ink tracking-tight" data-id="element-143">
                  Brenden Henry
                </h3>
                <p className="text-teal-600 font-semibold tracking-wide uppercase mt-2 text-sm" data-id="element-144">
                  World's #1 Peptide Authority
                </p>
              </div>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-ink-light font-light leading-relaxed" data-id="element-145">
              <p data-id="element-146">
                After designing life-saving ventilator systems still used in
                hospitals today... Brenden turned his engineering mind to human
                biology. With an emphasis on anti-aging and longevity... He's
                gone deeper into peptide science than almost anyone else alive.
              </p>
              <p data-id="element-147">
                He's thoroughly studied every major researcher and theory of
                aging. And used that knowledge to author Peptide Salvation and
                create Peptide Mastery... Both containing thousands of
                scientific citations.
              </p>
              <div className="pl-8 border-l-4 border-teal-400 text-ink italic" data-id="element-148">
                <p data-id="element-149">
                  His work has resulted in transformations modern medicine still
                  calls impossible: Reversing autoimmune diseases...
                  Regenerating organs... Reversing biological markers of
                  aging... And helping clients recover from type 1 and type 2
                  diabetes, kidney failure, traumatic brain injury, stroke,
                  Alzheimer's disease, severe drug withdrawal, and heart
                  failure.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12" data-id="element-150">
            <TestimonialCard text="I f**king love you man. I am now officially completely cured and honestly I'm just excited to see how much further we can take things!!" name="Michal J., Transformation Services Client" data-id="element-151" />
          </div>
        </div>

        {/* Pricing CTA */}
        <div className="bg-gradient-to-br from-[#1a1a2e] to-[#0f172a] text-white rounded-[3rem] p-8 md:p-20 text-center shadow-2xl space-y-8" data-id="element-152">
          <h3 className="text-3xl md:text-5xl font-bold tracking-tight" data-id="element-153">
            These are the two people you're getting access to.
          </h3>
          <p className="text-xl md:text-2xl text-white/80 font-light" data-id="element-154">
            Creating YOUR transformation program, personalized to you and
            expertly crafted to get you incredible results.
          </p>
          <div className="py-8" data-id="element-155">
            {isExpired ? <p className="text-2xl md:text-4xl font-bold" data-id="element-156">
                Book your Advanced session for{' '}
                <span className="text-[#38bdf8]" data-id="element-157">$5,000</span>.
              </p> : <p className="text-2xl md:text-4xl font-bold" data-id="element-158">
                And for the next 3 days... <br data-id="element-159" />
                You're getting this experience for{' '}
                <span className="text-[#38bdf8]" data-id="element-160">$1,500</span> instead of{' '}
                <span className="line-through opacity-50" data-id="element-161">$5,000</span>.
              </p>}
          </div>
          <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="block sm:inline-block w-full sm:w-auto px-12 py-6 bg-teal-600 hover:bg-teal-700 text-white text-lg sm:text-xl font-bold rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 text-center" data-id="element-162">
            Secure Your Slot Now – Only 20 Available
          </a>
        </div>
      </div>
    </div>;
}